import { Editor } from '@tinymce/tinymce-react';
import * as React from "react";
import { connect } from 'react-redux';
import PropTypes from "prop-types";

// TinyMCE so the global var exists
import 'tinymce/tinymce';
// DOM model
import 'tinymce/models/dom/model'
// Theme
import 'tinymce/themes/silver';
// Toolbar icons
import 'tinymce/icons/default';
// Editor styles
import 'tinymce/skins/ui/oxide/skin.min.css';

// importing the plugin js.
// if you use a plugin that is not listed here the editor will fail to load
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/lists';

// importing plugin resources
import 'tinymce/plugins/emoticons/js/emojis';

// Content styles, including inline UI like fake cursors
/* eslint import/no-webpack-loader-syntax: off */
import contentCss from '!!raw-loader!tinymce/skins/content/default/content.min.css';
import contentUiCss from '!!raw-loader!tinymce/skins/ui/oxide/content.min.css';

import {updateNotesField} from "../../../veritas/add-edit/actions/AddEditDPServiceActions";
import {updateNotesFieldForSource, updateSourceDetail} from "../../../veritas/add-edit/actions/AddEditDPSourceActions";
import { updateNotesFieldForCountry } from 'veritas/add-edit/actions/AddEditCountryActions';
import {setPricingFormDescriptionValueV2} from "../../../billing/pricing-tables/actions/PricingTablesActions";
import {setBillingGroupDescription} from "../../../veritas/add-edit/actions/AddEditBillingGroupActions";

/**
 * This is the implementation of the Editor component by tinymce-react built for Marvel.
 * Currently, the Editor component exposed by tinymce-react does not support custom props therefore there are
 * additional props given out on the DocumentEditor component. Right now, we only use this to write a few things
 * on notes and source which are added as boolean props and depending on the conditions the
 * right actions are dispatched to update the underlying object.
 *
 * Placeholder prop has been added to supply the custom string value to the Editor from
 * the Form component it is being rendered.
 *
 * One additional change this has brought is in the modals, the dimmer prop can no longer be used because it blurs out
 * the dropdowns rendered by Editor component.
 */

class DocumentEditor extends React.Component {

    static propTypes = {
        notes: PropTypes.bool,
        source: PropTypes.bool,
        country: PropTypes.bool,
        pricing: PropTypes.bool,
        billingGroup: PropTypes.bool,
        resourceType: PropTypes.string,
        placeholderText: PropTypes.string,
    }

    constructor(props) {
        super(props);

        this.state = {
            value: props.initialValue ?? '',
        };
        this.handleEditorChange = this.handleEditorChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.initialValue !== prevProps.initialValue) {
            this.setState({ value: this.props.initialValue ?? '' })
        }
    }

    handleEditorChange(value, editor) {
        this.setState({ value });
        this.updateObject(value)
    }

    updateObject(value) {
        const {notes, resourceType, source, country, pricing, billingGroup} = this.props;
        const name = resourceType;
        // dispatch action to update notes for a source
        if (notes && source) {
            this.props.updateNotesForSource({ name, value });
        }
        else if (notes && country ) {
            this.props.updateNotesForCountry({ name, value });
        }
        else if (notes) {
            // dispatch action to update notes for a service
            this.props.updateNotes({ name, value });
        } else if (source) {
            this.props.updateSourceDetail({ name, value });
        } else if (pricing) {
            this.props.updatePricingDescription({ name, value });
        } else if (billingGroup) {
            this.props.updateBillingGroupDescription({ name, value })
        }
    }

    render() {
        const { placeholderText } = this.props;
        return (
            <Editor
                // initialValue={this.props.initialValue}
                value={this.state.value}
                licenseKey="gpl"
                onEditorChange={this.handleEditorChange}
                init={{
                    height: "300px",
                    content_css: false,
                    content_style: [contentCss, contentUiCss].join('\n'),
                    placeholder: placeholderText,
                    menubar: false,
                    statusbar: false,
                    toolbar_mode: 'sliding',
                    plugins: 'lists advlist',
                    toolbar: 'undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    lists_indent_on_tab: true,
                    toolbar_sticky: true,
                }}
            />
        )
    }

}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = dispatch => ({
    updateNotes: ({ name, value }) => {dispatch(updateNotesField({ name, value }))},
    updateSourceDetail: ({name, value}) => {dispatch(updateSourceDetail({name, value}))},
    updateNotesForSource: ({ name, value }) => {dispatch(updateNotesFieldForSource({ name, value }))},
    updateNotesForCountry: ({ name, value }) => {dispatch(updateNotesFieldForCountry({ name, value }))},
    updatePricingDescription: ({ name, value }) => {dispatch(setPricingFormDescriptionValueV2({ name, value }))},
    updateBillingGroupDescription: ({ name, value }) => {dispatch(setBillingGroupDescription({ name, value }))},
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DocumentEditor);
